import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PinholeUserService {

    constructor(private httpClient: HttpClient) {

    }

    findUser(query: string): Observable<PinholeUser | null> {
        return this.httpClient.get<PinholeUser>("/rest/admin/find_user/" + query).pipe(
            catchError(() => of(null))
        )
    }

    changeLogin(changeLoginRequest: ChangeLoginRequest): Observable<PinholeUser | null> {
        return this.httpClient.post<PinholeUser>(`/rest/admin/change_login`, changeLoginRequest).pipe(
            catchError(() => of(null))
        )
    }

    addProperty(addPropertyRequest: AddPropertyRequest): Observable<any | null> {
        return this.httpClient.post(`/rest/admin/add_property`, addPropertyRequest).pipe(
            catchError(() => of(null))
        )
    }
}

export interface AddPropertyRequest {
    iid: string;
    name: string;
    value: string;
}

export interface ChangeLoginRequest {
    iid: string;
    newLogin: string;
}

export interface PinholeUser {
    login: string | null;
    iid: string,
    installs: PinholeInstall[];
    rounds: PinholeRound[];
    properties: Property[];
}

export interface PinholeInstall {
    iid: string;
    roundsCount: number;
    timestamp: number;
    deviceModel: string | null,
    appVersion: string | null,
    pairedWatchesInfo: PairedWatch | null
}

export interface PairedWatch {
    deviceModel: string | null,
    appVersion: string | null,
    osVersion: string | null
}

export interface PinholeRound {
    iid: string;
    token: string;
    timestamp: number;
    isDeleted: boolean;
}

export interface Property {
    commitTs: number;
    isDeleted: boolean;
    type: string;
}

export interface Default extends Property {
    key: string;
}

export interface Contact extends Property {
    name: string;
    email: string;
}

export interface License extends Property {
    value: string;
}

export interface ClientInstallReferrer extends Property {
    referrer: string;
    installVersion: string;
    date: string;
}

export interface Club extends Property {
    id: number;
    nfcId: string;
    clubType: string;
    isInBag: boolean;
    isClubDeleted: boolean;
}

export interface ClubList extends Property {
    clubs: Club[];
}
